/*
 * @Author: your name
 * @Date: 2020-10-12 11:46:55
 * @LastEditTime: 2021-03-31 15:00:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zlj_fantastic/src/ui-boot.ts
 */
import Vue from 'vue'
import {
  Icon,
  Tab,
  Tabs,
  Toast,
  Dialog,
  NavBar,
  FixTop,
  SimpleSticky,
  Button,
  Lazyload,
  NoticeBar,
  ButtonGroup,
  Swipe,
  SwipeItem,
  PageBaseBox,
  Divider,
  Image,
  Row,
  Col,
  Checker,
  Step,
  Steps,
  Switch,
  Popup,
  List,
  Countup
} from '@zz-common/zz-ui'

export default () => {
  Vue.use(Icon)
  Vue.use(Tab)
  Vue.use(Tabs)
  Vue.use(Toast)
  Vue.use(Swipe)
  Vue.use(Dialog)
  Vue.use(NavBar)
  Vue.use(FixTop)
  Vue.use(SimpleSticky)
  Vue.use(Button)
  Vue.use(Lazyload)
  Vue.use(SwipeItem)
  Vue.use(NoticeBar)
  Vue.use(ButtonGroup)
  Vue.use(PageBaseBox)
  Vue.use(Divider)
  Vue.use(Image)
  Vue.use(Row).use(Col)
  Vue.use(Checker)
  Vue.use(Step).use(Steps)
  Vue.use(Switch)
  Vue.use(Popup)
  Vue.use(List)
  Vue.use(Countup)
}
